export const SESSION_FORMATS = {
  IMPORT_LONG: 'long',
  STANDARD: 'standard',
}
